<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="stop-circle-outline"></nb-icon>
        <div class="ml-2" i18n>Terminating Campaign: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="d-flex flex-column">
      <div class="m-2" i18n>Provide a reason for terminating the run:</div>
      <input class="m-2" nbInput fullWidth [(ngModel)]="reasonText" [ngModelOptions]="{ standalone: true }" />
      <div class="m-2" i18n>Are you sure you want to terminate this campaign?</div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>No</button>
      <button nbButton class="ml-3" [disabled]="!reasonText" status="danger" (click)="terminate()" i18n>Yes</button>
    </div>
  </nb-card-footer>
</nb-card>
